const debug = false;

import '@aamasri/web-components/src/js/string-prototypes';    // prototype .ucFirst()


/////// Begin Inspectlet Asynchronous Code ///////
(function() {
    if (typeof inspectletWebsiteId !== 'number' || !inspectletWebsiteId || environment === 'development') {
        // debugging for Ananda only
        if (typeof visitorId !== 'number' || visitorId > 2)
            if (debug) console.debug('inspectlet not active (INSPECTLET_WEBSITE_ID must be specified in .env AND environment !== "development"');

        return;
    }

    window.__insp = window.__insp || [];
    __insp.push(['wid', inspectletWebsiteId]);

    // add visitor identity to inspectlet session
    if (typeof visitor !== 'undefined' && visitor.id) {
        const visitorIdentity = { name: visitor.name, email: visitor.email, userId: visitor.id };
        __insp.push(['tagSession', visitorIdentity ]);
        __insp.push(['identify', visitor.name ]);
    }

    const ldinsp = function() {
        if (typeof window.__inspld != 'undefined')
            return;

        window.__inspld = 1;
        const inspectlet = document.createElement('script');
        inspectlet.type = 'text/javascript';
        inspectlet.async = true;
        inspectlet.id = 'inspsync';
        inspectlet.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=194769025&r=' + Math.floor(new Date().getTime()/3600000);
        const x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(inspectlet, x);
    };
    setTimeout(ldinsp, 0);
})();
/////// End Inspectlet Asynchronous Code ///////



///////////// PAGE VISIBILITY API (APP ANALYTICS) //////////////
(function() {
    // store page loads in local storage so that we can track page views
    // but ignore page visits lasting less than 10 seconds. This delay also
    // reduces initial page load processing overhead.
    window.setTimeout(function() {
        let clientEvent = {
            url: window.location.pathname,
            event: 'onPageLoad',            // e.g. 'onLocationChange', 'onClick', 'onScroll', 'onPageLoad'
            timestamp: Math.round(Date.now() / 1000),   // convert to seconds
        };
        log(clientEvent);

        // warn if the browser doesn't support addEventListener or the Page Visibility API
        if (typeof document.addEventListener !== 'function' || typeof localStorage !== 'object' || typeof document.visibilityState !== 'string') {
            if (debug) console.warn('This browser does NOT fully support the Page Visibility API.');
        } else {
            if (debug) console.log("This browser supports the Page Visibility API. Adding visibilitychange event listener.");

            // capture page visibility change events
            document.addEventListener('visibilitychange', handleVisibilityChange, false);
        }
    }, debug ? 100 : 10000);



    function handleVisibilityChange() {
        if (debug) console.log(`browser tab ${window.location.pathname} is ${document.visibilityState}`);

        // log browser visibility event
        const clientEvent = {
            url: window.location.pathname,
            event: `onPage${document.visibilityState.ucFirst()}`,
            timestamp: Math.round(Date.now() / 1000),   // convert to seconds
        };
        log(clientEvent);

        const pageHistory = localStorage.getItem('pageHistory');
        // hidden state is a good time to send the logs to the server
        // as the tab is likely to be closed soon
        if (document.visibilityState === 'hidden' && pageHistory) {
            const headers = { type: 'application/json' };
            const blob = new Blob([pageHistory], headers);
            if (typeof navigator.sendBeacon === 'function') {
                try {
                    if (navigator.sendBeacon('/analytics/logs', blob)) {
                        if (debug) console.log('Analytics transmitted! Flushing local log');
                        localStorage.removeItem('pageHistory');
                    }
                } catch (e) {
                    console.error('sendBeacon failed with', e.toString());
                }
            }
        }
    }


    function log(clientEvent) {
        // ignore duplicate or equivalent events
        const pageHistory = JSON.parse(localStorage.getItem('pageHistory')) || [];
        const pageHistorySize = pageHistory.length;
        if (pageHistorySize) {
            const lastEvent = pageHistory[pageHistorySize - 1];
            const urlMatch = lastEvent.url === clientEvent.url;
            const eventMatch = lastEvent.event === clientEvent.event || (lastEvent.event === 'onPageLoad' && clientEvent.event === 'onPageVisible');
            if (urlMatch && eventMatch)
                return;
        }

        // log the event to local storage
        pageHistory.push(clientEvent);
        localStorage.setItem('pageHistory', JSON.stringify(pageHistory));
    }


}());

///////////// END OF PAGE VISIBILITY API //////////////